export function formatDateTime(date: string | Date, locale?: string): string {
  return new Date(date).toLocaleString(locale, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function formatDate(date: string | Date, locale?: string): string {
  return new Date(date).toLocaleDateString(locale, {
    dateStyle: "medium",
  });
}
